import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import { useEffect, useState } from "react";
import { handleRetriveError } from "../../utils";

interface Plugin {
  logo: JSX.Element | string; // Adjust type based on the actual data structure
  name: string;
  description: string;
}

function PluginMain() {
  const [pluginList, setPluginList] = useState<Plugin[]>([]);
  const api = useApi();

  useEffect(() => {
    api.getPlugginList().then((response: any) => {
        setPluginList(response);
      }, handleRetriveError);
  }, []);

  return (
    <PageBodyWrapper>
      <section className="p-6">
        <header className="flex flex-row justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Installed Plugins</h1>
        </header>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pluginList.length > 0 ? (
            pluginList.map((plugin, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg p-4 hover:shadow-lg transition duration-200"
              >
                <div className="flex flex-col items-center">
                  <div className="mb-4">
                    {typeof plugin.logo === "string" ? (
                      <img
                        src={plugin.logo}
                        alt={`${plugin.name} logo`}
                        className="h-16 w-16 object-contain"
                      />
                    ) : (
                      plugin.logo
                    )}
                  </div>
                  <h2 className="text-lg font-semibold text-gray-700">{plugin.name}</h2>
                  <p className="text-sm text-gray-500 text-center mt-2">{plugin.description}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 col-span-full">
              No plugins installed.
            </p>
          )}
        </div>
      </section>
    </PageBodyWrapper>
  );
}

export default PluginMain;
